// Only compare the known OBS layout. Unknown URLs are not genre evidence.
export function musicUrlFolder(value) {
  try {
    const url = new URL(value)
    const parts = url.pathname.split('/').filter(Boolean).map(decodeURIComponent)
    return url.hostname === 'clubf5oficial.obs.sa-argentina-1.myhuaweicloud.com' &&
      parts[0] === 'Music' && parts[1] === 'online' && parts.length >= 4 ? parts[2] : null
  } catch { return null }
}

export function hasMusicFolderConflict(row) {
  const folder = musicUrlFolder(row.url ?? row.link)
  return folder !== null && folder !== row.folder
}

export function musicDay(row) {
  const raw = row.numeroDia ?? row.clprra_numeroDia ?? row.numerodia
  if ((typeof raw !== 'number' && typeof raw !== 'string') || raw === '' || (typeof raw === 'string' && !raw.trim())) return null
  const day = Number(raw)
  return Number.isInteger(day) && day >= 0 && day <= 6 ? day : null
}

export function validServerMusic(row, folder, day) {
  return typeof row?.link === 'string' && row.link.length > 0 && row.folder === folder &&
    musicDay(row) === day && !hasMusicFolderConflict(row)
}

// Never copy blob, id, code, creation time or playback history from remote metadata.
export function musicMetadataPatch(row) {
  return { folder: row.folder, title: row.title, initH: row.initH, endH: row.endH,
    numerodia: musicDay(row), metadataVerifiedAt: new Date().toISOString() }
}

// A partial legacy OBS response cannot prove that a local file was deleted.
export function canDeleteFromMusicVerification(result, folder, day) {
  return result?.catalogComplete === true && result.folders === folder &&
    result.currentDay === day && !result.error
}
